export const STATUS_META = {
  not_started: { label: "Not started", dot: "#9CA3AF", badge: "bg-stone-100 text-stone-600 border-stone-300" },
  in_progress: { label: "In progress", dot: "#0284C7", badge: "bg-sky-50 text-sky-700 border-sky-300" },
  completed: { label: "Completed", dot: "#10B981", badge: "bg-emerald-50 text-emerald-700 border-emerald-400" },
  needs_review: { label: "Needs review", dot: "#F59E0B", badge: "bg-amber-50 text-amber-800 border-amber-300" },
};

export function interpret(score) {
  if (score == null) return { label: "—", color: "#78716c", bg: "bg-stone-50", badge: "text-stone-500" };
  if (score < 5) return { label: "Needs immediate attention", color: "#DC2626", bg: "bg-rose-50", badge: "text-rose-700" };
  if (score < 8) return { label: "Needs improvement", color: "#D97706", bg: "bg-amber-50", badge: "text-amber-700" };
  return { label: "Well done — maintain", color: "#15803D", bg: "bg-emerald-50", badge: "text-emerald-700" };
}
